export default __webpack_public_path__ + "static/media/fossil6.5db8c794.png";